import SkeletonTable from "@/components/SkeletonTable"
import api from "@/lib/axios"
import { useQuery } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import { DataTable } from "./partial/DataTable"
import { columns } from "./partial/Columns"

const getListKelompokVerifikasiPesertaSkl = async (id_verskl_rekap: string) => {
  const response = await api.get(
    `/setting/verifikator-skl/show-kelompok/${id_verskl_rekap}`,
    {
      withCredentials: true,
    }
  )
  return response.data
}

export default function SettingVerifikatorSklDetailPage() {
  const [searchParams] = useSearchParams()
  const idVersklRekap = searchParams.get("id")

  const { data, isPending } = useQuery({
    queryKey: ["listKelompokVerifikasiPesertaSkl", idVersklRekap],
    queryFn: () => getListKelompokVerifikasiPesertaSkl(String(idVersklRekap)),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data?.data || []} columns={columns} />
    </div>
  )
}
